<template>
  <SloField class="slo-check-list" tag="div">
    <slot />
    <ul class="check-list" v-stack-y:xs>
      <li v-if="selectAll">
        <SloInput
          type="checkbox"
          value="select-all"
          :indeterminate="all === 'some'"
          :checked="all === 'all'"
          @input="checkAll()"
          class="select-all"
        >
          <template v-slot:end>
            <span class="select-all-label">
              {{ 'Select All' | t }}
            </span>
          </template>
        </SloInput>
      </li>
      <li v-for="item of resolvedItems" :key="item.value">
        <SloInput
          v-bind="item"
          type="checkbox"
          :value="item.value"
          :checked="value.indexOf(item.value) > -1"
          @input="toggleItem(item.value, $event)"
        >
          <template v-slot:end>
            <span class="checklist-label">
              {{ item.label }}
              <SloIcon v-if="item.disabled && item.reason" name="TriangleExclamation" />
              <span v-if="item.disabled && item.reason" class="checklist-tooltip" data-placement="right" v-html="item.reason" />
            </span>
          </template>
        </SloInput>
      </li>
    </ul>
  </SloField>
</template>

<script>
import t from '../../js/main/i18n';
import SloField from './SloField.vue';
import SloInput from './SloInput.vue';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloCheckList',
  components: {
    SloField,
    SloInput,
    SloIcon
  },
  filters: {
    t
  },
  props: {
    selectAll: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      validator: items =>
        items.every(item => {
          if (typeof item === 'string') return true;
          return typeof item === 'object' && item.value && item.label;
        })
    },
    value: {
      type: Array,
      validator: values => {
        return values.every(value => typeof value === 'string');
      },
      default: () => []
    }
  },
  computed: {
    all() {
      if (this.value.length === this.items.length) {
        return 'all';
      } else if (this.value.length > 0) {
        return 'some';
      } else {
        return 'none';
      }
    },
    resolvedItems() {
      return this.items.map(item =>
        typeof item === 'string' ? {value: item, label: item} : item
      );
    }
  },
  methods: {
    checkAll() {
      if (this.all === 'none') {
        this.$emit(
          'input',
          this.items.map(item => item.value)
        );
      } else {
        this.$emit('input', []);
      }
    },
    toggleItem(value, checked) {
      const newValue = this.value.slice(0);
      if (checked) {
        newValue.push(value);
      } else {
        newValue.splice(newValue.indexOf(value), 1);
      }

      this.$emit('input', newValue);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-check-list .check-list {
  padding: 0;
  pointer-events: none;

  & > li {
    list-style: none;
    pointer-events: initial;
  }

  .select-all-label {
    @include text('base', 'strong');
  }

  .checklist-label {
    position: relative;
    display: flex;
    align-items: center;

    .slo-icon {
      margin-left: 4px;
      pointer-events: initial;
      color: #ff5b5b;

      &:hover {
        + .checklist-tooltip {
          opacity: 1;
        }
      }
    }

    .checklist-tooltip {
      position: relative;
      font-size: 14px;
      min-width: min-content;
      margin-left: 7px;
      padding: 5px 8px;
      background-color: $color-gray-900;
      color: #fff;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      white-space: nowrap;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -4px;
        width: 0;
        height: 0;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-right: 4px solid $color-gray-900;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
